import styled from 'styled-components';
import { H2Style } from '../P/textStyle';

const H2 = styled.h2`
  ${H2Style};
`;

export default H2;
